<template>
  <div class="row">
    <div class="col-md-8">
      <h3> {{ $route.params.merchant.toUpperCase() }}</h3>
    </div>
    <div class="col-md-2 offset-md-2">
      <router-link :to="{ name: ''}" style="float:right">
        <p-button type="primary" round disabled>
          Redeem
        </p-button>
      </router-link>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="col-sm-12 mt-2">
            
            <div class="card" v-for="(data, index) in queriedData" :key="index">
              <div class="card-body" style="border-left: 6px solid" 
                :style="data.type_id == 1 ? 'border-color:#6bd098': 'border-color:#ef8157'" >
                <div class="row">
                  <div style="width:100%">
                    <span class="col-md-2 float-left">{{data.transaction_date}}</span>
                    <span class="col-md-3  offset-md-2 float-right"  
                      style="text-align:right">{{data.amount}}</span>
                  </div>
                </div>
                <div style="border-top: 1px #ebeef5 solid;line-height: 20px;">{{data.remark}}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from 'src/components/UIComponents'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  

  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import categories from 'src/categories'
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    components: {
      Card,
      ChartCard,
      PPagination
    },
    watch: {
      tableData: function(){
        this.queriedData
      }
    },

    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [10, 25, 50],
          total: 0
        },

        tableData: []
      }
    },
    methods: {
    
      getTransactions () {
        this.$http.get ('/rewards/' + this.$route.params.merchant +  '/transactions')
        .then(response => {

          if(response.data.length == 0 ) {
            return
          }

          response.data.map(function (e) {
            e.amount = new Intl.NumberFormat('en-US', 
                { style: 'currency', currency: 'NGN' }).format(e.amount / 100).replace('NGN', '₦')
            
            e.transaction_date = e.transaction_date.substring(0, 10)
          });

          this.tableData = response.data
          
        })
        .catch(err => console.error(err))
      },
    },
    async mounted () {
      this.getTransactions ()

    }
  }
</script>
<style lang="scss">
  .el-table .td-actions {
    button.btn {
      margin-right: 5px;
    }
  }

 
</style>
